import { EnvironmentModel } from './environment.model';
import { PROJECT_NAME, VERSION } from './environment.variables';

export const environment: EnvironmentModel = {
  projectName: PROJECT_NAME,
  version: VERSION,
  production: false,
  env: 'dev',
  api: 'https://api.greenpharm.k8s.touch4dev.net/api',
  features: {
    labelValidationApi: true,
    localLogin: true,
  },
};
